import React from "react";
import { Article } from "../../types";
import { AnalyticsEvent } from "../../analytics/track";
import { useAnalytics } from "../../hooks/analytics";
import { useSearchQuery } from "../../providers/search_query_provider";
import { useSearchRouting } from "../../providers/search_routing_provider";

type SearchArticleProps = {
  article: Article;
};

export function SearchArticle({ article }: SearchArticleProps) {
  const { normalizedQuery } = useSearchQuery();
  const { routing } = useSearchRouting();
  const { track } = useAnalytics();

  return (
    <li key={article.text}>
      <a
        href={article.href}
        className="dewey--search--article"
        onClick={() =>
          track(AnalyticsEvent.SEARCH_RESULTS_CLICKED, {
            query: normalizedQuery,
            query_type: routing,
            result_type: "article",
            result_value: article,
          })
        }
      >
        {article.text}
      </a>
    </li>
  );
}
